import { useEffect } from "react";

import { useNode } from "@craftjs/core";

import { useCraftCustom, useCraftProperty } from "../../core/hooks";
import { useStateContext } from "../../utils/State";

export function useConditional() {
  const { show: { setValue: setShow, value } } = useStateContext()
  const { value: show } = useCraftProperty(`properties.show`, value)

  useEffect(() => {
    setShow(show)
  }, [show, setShow])
}

export function useLegacyConditional() {
  const { options: { register } } = useStateContext()

  const { value: legacyTrueId } = useCraftProperty('trueId')
  const { value: legacyFalseId } = useCraftProperty('falseId')

  useEffect(() => {
    legacyTrueId && register('true', { id: legacyTrueId })
    legacyFalseId && register('false', { id: legacyFalseId })
  }, [register, legacyTrueId, legacyFalseId])
}

export function useRegisterConditionalCase() {
  const { id } = useNode()
  const { options: { register } } = useStateContext()
  const { value: { type, name } } = useCraftCustom('state')

  useEffect(() => {
    register(type, { id, name })
  }, [register, type, name, id])
}
